<template>
    <div
        class="ArrowBttn"
        :class="modifiers"
        @click="onClick"
        @mouseenter="toggleHovered"
        @mouseleave="toggleHovered"
    >
        <svg class="ArrowBttn-icon">
            <use xlink:href="#icon-chevron-down"></use>
        </svg>
        <text-transition
            :charMinDuration="0.3"
            :charMaxDuration="0.5"
            :outroDuration="0.5"
        >
            <span v-show="isHovered" class="ArrowBttn-tooltip">
                <small>{{directionText}}</small>
            </span>
        </text-transition>
    </div>
</template>

<script>
    import TextTransition from "../transitions/TextTransition"

    export default {
        name: 'ArrowBttn',
        data() {
            return {
                isHovered: false
            }
        },
        components: {
            TextTransition
        },
        props: {
            up: {
                type: Boolean,
                default: false,
            },
            light: {
                type: Boolean,
                default: false,
            },
            bordered: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            onClick(ev) {
                const {disabled} = this
                if (!disabled) {
                    this.$emit('click', ev)
                }
            },
            toggleHovered() {
                this.isHovered = !this.isHovered;
            },
        },
        computed: {
            directionText() {
                return this.up ? "artista anterior" : "artista siguiente";
            },
            modifiers() {
                const {up, light, disabled, bordered} = this;
                return {
                    'ArrowBttn--up': up,
                    'ArrowBttn--light': light,
                    'ArrowBttn--bordered': bordered,
                    'ArrowBttn--disabled': disabled,
                }
            },
        },
    }
</script>

<style src="styles/components/ArrowBttn.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/ArrowBttn.vue